<div class="notes-card" [class.notes-card--pending-review]="isPendingReview">
  <div class="notes-card__header" (click)="toggleCard()">
    <div class="notes-card__header-left">
      <mat-icon [svgIcon]="isPendingReview ? 'other_icons_warning' : 'other_icons'" class="notes-card__icon"></mat-icon>
      <div class="notes-card__header-texts">
        <span class="notes-card__title">Resumen de la clase introductoria (IA)</span>
        @if (isPendingReady) {
          <span class="notes-card__subtitle">Genera automáticamente un resumen a partir de la transcripción del vídeo.</span>
        }
        @if (isPendingReview) {
          <span class="notes-card__subtitle notes-card__subtitle--pending">Resumen generado — pendiente de revisión</span>
        }
      </div>
    </div>

    @if (isPendingReview) {
      <button
        type="button"
        class="notes-cta notes-cta--review"
        [disabled]="isMarkingReviewed || notesView?.notesStatus === 'processing'"
        (click)="$event.stopPropagation(); markAsReviewed()"
      >
        @if (isMarkingReviewed) {
          <mat-spinner diameter="14"></mat-spinner>
        } @else {
          <svg width="15" height="11" viewBox="0 0 15.3125 10.9375" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.75 0.25c0.33 0.33 0.33 0.87 0 1.2l-9.33 9.33c-0.16 0.16-0.37 0.25-0.6 0.25s-0.44-0.09-0.6-0.25l-4-4c-0.33-0.33-0.33-0.87 0-1.2 0.33-0.33 0.87-0.33 1.2 0l3.4 3.4 8.73-8.73c0.33-0.33 0.87-0.33 1.2 0z"
              fill="#16bd5b"
              fill-rule="evenodd"
            />
          </svg>
        }
        Marcar como revisado
      </button>
    }

    <!-- Hidden while the review button shows — same as the normal class: with just two children
     (header-left + button) left in the row, `justify-content: space-between` pins the button to
     the right edge on its own; adding the chevron back in would split the row into three and
     leave the button stranded in the middle instead. -->
    @if (!isPendingReview) {
      @if (isCardExpanded) {
        <svg class="notes-card__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m4 12 6-6 6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      } @else {
        <svg
          class="notes-card__chevron notes-card__chevron--down"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m4 8 6 6 6-6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      }
    }
  </div>

  @if (isCardExpanded) {
    <div class="notes-card__body">
      @if (isLoading) {
        <div class="notes-state notes-state--loading">
          <mat-spinner diameter="24" class="notes-state__spinner"></mat-spinner>
          <div class="notes-state__texts">
            <span class="notes-state__title">Cargando resumen...</span>
          </div>
        </div>
      }

      @if (!isLoading && notesView) {
        <!-- Transcript states — gate everything else, same order as the normal class's card. -->
        @if (notesView.transcriptStatus === 'error') {
          <div class="notes-state notes-state--error">
            <svg class="notes-state__error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.609 1.5h10.782l5.609 5.61v10.78L17.391 23.5H6.609L1 17.89V7.11L6.609 1.5Z"
                fill="none"
                stroke="#e03131"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path d="m8.219 8.219 7.562 7.562M15.781 8.219l-7.562 7.562" stroke="#e03131" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="notes-state__texts">
              <span class="notes-state__title">Se ha producido un error al generar la transcripción</span>
              <span class="notes-state__subtitle">{{ transcriptErrorFallback }}</span>
            </div>
            <button type="button" class="notes-cta" [disabled]="isGeneratingTranscript" (click)="generateTranscript()">
              @if (isGeneratingTranscript) {
                <mat-spinner diameter="14"></mat-spinner>
              }
              Reintentar transcripción
            </button>
          </div>
        }

        @if (notesView.transcriptStatus === 'processing') {
          <div class="notes-state notes-state--generating">
            <mat-spinner diameter="28" class="notes-state__spinner"></mat-spinner>
            <div class="notes-state__texts">
              <span class="notes-state__title">Generando transcripción…</span>
              <span class="notes-state__subtitle">Procesando el audio del vídeo. Esto puede tardar unos segundos.</span>
            </div>
          </div>
        }

        @if (notesView.transcriptStatus === 'pending') {
          <div class="notes-state notes-state--hint">
            <span class="notes-state__subtitle">Sin transcripción de vídeo disponible. Genera la transcripción primero.</span>
            <button type="button" class="notes-cta" [disabled]="isGeneratingTranscript" (click)="generateTranscript()">
              @if (isGeneratingTranscript) {
                <mat-spinner diameter="14"></mat-spinner>
              }
              Generar transcripción
            </button>
          </div>
        }

        <!-- Notes states, only once the transcript is ready and there's no text yet. -->
        @if (notesView.transcriptStatus === 'ready' && !notesView.notesText) {
          @if (notesView.notesStatus === 'processing') {
            <div class="notes-state notes-state--generating">
              <mat-spinner diameter="28" class="notes-state__spinner"></mat-spinner>
              <div class="notes-state__texts">
                <span class="notes-state__title">Generando resumen...</span>
                <span class="notes-state__subtitle">Analizando la transcripción del vídeo. Esto puede tardar unos segundos.</span>
              </div>
            </div>
          } @else if (notesView.notesStatus === 'error') {
            <div class="notes-state notes-state--error">
              <svg class="notes-state__error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.609 1.5h10.782l5.609 5.61v10.78L17.391 23.5H6.609L1 17.89V7.11L6.609 1.5Z"
                  fill="none"
                  stroke="#e03131"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path d="m8.219 8.219 7.562 7.562M15.781 8.219l-7.562 7.562" stroke="#e03131" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <div class="notes-state__texts">
                <span class="notes-state__title">Se ha producido un error al generar el resumen</span>
                <span class="notes-state__subtitle">{{ notesErrorLabels[notesView.notesErrorCode ?? 'unknown'] || notesErrorFallback }}</span>
              </div>
              <button type="button" class="notes-cta" [disabled]="isGeneratingNotes" (click)="generateNotes()">
                @if (isGeneratingNotes) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Reintentar
              </button>
            </div>
          } @else {
            <div class="notes-state notes-state--hint">
              <span class="notes-state__subtitle">Transcripción lista. Genera el resumen con IA.</span>
              <button type="button" class="notes-cta notes-cta--generate" [disabled]="isGeneratingNotes" (click)="generateNotes()">
                @if (isGeneratingNotes) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Generar resumen IA
              </button>
            </div>
          }
        }

        <!-- Content editor (ready, or processing/error with prior content) — same Quill editor as
         the normal class, same toolbar, same markdown<->HTML conversion via marked/turndown. -->
        @if (notesView.notesStatus === 'ready' || notesView.notesText) {
          <div class="notes-content" [class.notes-content--disabled]="notesView.notesStatus === 'processing'">
            <quill-editor
              [(ngModel)]="editorContent"
              [modules]="quillModules"
              [readOnly]="notesView.notesStatus === 'processing'"
              (onContentChanged)="onEditorContentChange($event)"
              (onEditorCreated)="onEditorCreated($event)"
              placeholder="Contenido del resumen..."
              theme="snow"
            >
            </quill-editor>

            @if (notesView.notesStatus === 'processing') {
              <div class="notes-editor__regenerating">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Regenerando resumen…</span>
              </div>
            }
          </div>

          <span class="notes-editor__label">Texto del resumen</span>

          <div class="notes-card__row">
            <app-enfaf-switch-dark
              [control]="publishedControl"
              label="Mostrar resumen"
              [disabled]="notesView.notesStatus === 'processing'"
              (onChange)="togglePublished($event)"
            ></app-enfaf-switch-dark>

            <div class="notes-card__actions">
              <button
                type="button"
                class="notes-cta"
                [disabled]="notesView.notesStatus === 'processing' || isGeneratingNotes"
                (click)="generateNotes()"
              >
                @if (isGeneratingNotes) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Regenerar
              </button>

              <button type="button" class="notes-cta notes-cta--danger" [disabled]="isDeleting" (click)="deleteNotes()">
                @if (isDeleting) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Eliminar
              </button>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
